(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.live-most-traded', ['pp.widgets-templates', 'pp.services.core', 'pp.filters.numbers', 'pp.widgets.live-item']);

var DEBOUNCE_MILLIS = 2000;

ngModule.directive('ppLiveMostTraded', [function () {
    return {
        restrict: 'A',
        templateUrl: 'widgets/_angular/live-most-traded/live-most-traded.tpl.html',
        scope: {
            mostTraded: '<ppLiveMostTraded',
            initialItem: '<',
            slideRight: '&',
            slideLeft: '&'
        },
        controllerAs: 'vm',
        bindToController: true,
        controller: ['$scope', '$timeout', '$filter', '$window', 'ppTrack', function ($scope, $timeout, $filter, $window, ppTrack) {
            var vm = this;

            // -- initial state
            var currentItemKey = 'firstItem';

            vm.dummyTrade = {
                timestamp: 10000,
                details: [{
                    label: 'Current Price',
                    value: '100'
                }, {
                    label: 'Cumulative Value',
                    value: '100'
                }, {
                    label: '% Change',
                    value: '1.0%'
                }]
            };

            // -- util functions

            function slideItemIn(newItem) {
                if (currentItemKey === 'firstItem') {
                    vm.secondItem = angular.copy(newItem);
                    vm.previousItem = vm.firstItem.id;
                    currentItemKey = 'secondItem';
                } else {
                    vm.firstItem = angular.copy(newItem);
                    vm.previousItem = vm.secondItem.id;
                    currentItemKey = 'firstItem';
                }
                vm.currentItem = newItem.id;
            }

            function slideLeft(newItem) {
                vm.slideType = 'slide-left';
                slideItemIn(newItem);
            }

            function slideRight(newItem) {
                vm.slideType = 'slide-right';
                slideItemIn(newItem);
            }

            // -- api

            vm.linkClicked = function (symbol) {
                ppTrack.deferAction('live-ticker.most-traded.click', {
                    symbol: symbol
                });
            };

            // -- scope bindings

            vm.$onInit = function () {
                vm.periodInDays = vm.mostTraded && vm.mostTraded[0] && vm.mostTraded[0].periodInHours ? vm.mostTraded[0].periodInHours / 24 : 'N/A';

                $scope.$on('pp.live-marketplace.most-traded.slide-right', function (ev, newItem) {
                    slideRight(newItem);
                });

                $scope.$on('pp.live-marketplace.most-traded.slide-left', function (ev, newItem) {
                    slideLeft(newItem);
                });

                vm.slideType = 'initial';
                vm.firstItem = angular.copy(vm.initialItem);
                vm.currentItem = vm.firstItem.id;
            };

        }]
    };
}]);
})(window, window.angular);